"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledParagraph = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Text_types_1 = require("./Text.types");
exports.StyledParagraph = styled_components_1.default.p `
  display: inline;
  margin: 0;
  padding: 0;
  color: ${({ color, theme }) => theme.colors['text-colours'][color].value};
  ${({ theme, textStyle }) => (0, styled_components_1.css) `
      font-family: ${theme.typography.desktop.text[textStyle]['font-family'].value};
      font-size: ${theme.typography.desktop.text[textStyle]['font-size'].value};
      letter-spacing: ${theme.typography.desktop.text[textStyle]['letter-spacing'].value};
      line-height: ${theme.typography.desktop.text[textStyle]['line-height'].value};
      font-weight: ${theme.typography.desktop.text[textStyle]['font-weight'].value};
    `}
  text-align: ${({ align }) => align !== null && align !== void 0 ? align : Text_types_1.TextAlign.Left};
  ${({ theme, textStyle }) => {
    var _a, _b;
    return ((_a = theme.typography.desktop.text[textStyle]['text-transform']) === null || _a === void 0 ? void 0 : _a.value) &&
        (0, styled_components_1.css) `
      text-transform: ${(_b = theme.typography.desktop.text[textStyle]['text-transform']) === null || _b === void 0 ? void 0 : _b.value};
    `;
}}
  ${({ theme, textStyle }) => {
    var _a, _b;
    return ((_a = theme.typography.desktop.text[textStyle]['text-decoration']) === null || _a === void 0 ? void 0 : _a.value) &&
        (0, styled_components_1.css) `
      text-decoration: ${(_b = theme.typography.desktop.text[textStyle]['text-decoration']) === null || _b === void 0 ? void 0 : _b.value};
    `;
}}
  ${({ italic }) => italic &&
    (0, styled_components_1.css) `
      font-style: italic;
    `}
  ${({ ellipsis }) => ellipsis &&
    (0, styled_components_1.css) `
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    `}
  ${({ width }) => width !== undefined &&
    (0, styled_components_1.css) `
      display: block;
      width: ${width};
    `}
  ${({ textStyle, theme }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return (0, styled_components_1.css) `
    @media screen and (max-width: ${(_a = theme.layout.small['device-max-width']) === null || _a === void 0 ? void 0 : _a.value}) {
      ${(0, styled_components_1.css) `
        font-family: ${theme.typography.tablet.text[textStyle]['font-family'].value};
        font-size: ${theme.typography.tablet.text[textStyle]['font-size'].value};
        letter-spacing: ${theme.typography.tablet.text[textStyle]['letter-spacing'].value};
        line-height: ${theme.typography.tablet.text[textStyle]['line-height'].value};
        font-weight: ${theme.typography.tablet.text[textStyle]['font-weight'].value};
      `}
      ${((_b = theme.typography.tablet.text[textStyle]['text-transform']) === null || _b === void 0 ? void 0 : _b.value) &&
        (0, styled_components_1.css) `
        text-transform: ${(_c = theme.typography.tablet.text[textStyle]['text-transform']) === null || _c === void 0 ? void 0 : _c.value};
      `}
      ${((_d = theme.typography.tablet.text[textStyle]['text-decoration']) === null || _d === void 0 ? void 0 : _d.value) &&
        (0, styled_components_1.css) `
        text-decoration: ${(_e = theme.typography.tablet.text[textStyle]['text-decoration']) === null || _e === void 0 ? void 0 : _e.value};
      `}
    }
    @media screen and (max-width: ${(_f = theme.layout.xsmall['device-max-width']) === null || _f === void 0 ? void 0 : _f.value}) {
      ${(0, styled_components_1.css) `
        font-family: ${theme.typography.mobile.text[textStyle]['font-family'].value};
        font-size: ${theme.typography.mobile.text[textStyle]['font-size'].value};
        letter-spacing: ${theme.typography.mobile.text[textStyle]['letter-spacing'].value};
        line-height: ${theme.typography.mobile.text[textStyle]['line-height'].value};
        font-weight: ${theme.typography.mobile.text[textStyle]['font-weight'].value};
      `}
      ${((_g = theme.typography.mobile.text[textStyle]['text-transform']) === null || _g === void 0 ? void 0 : _g.value) &&
        (0, styled_components_1.css) `
        text-transform: ${(_h = theme.typography.mobile.text[textStyle]['text-transform']) === null || _h === void 0 ? void 0 : _h.value};
      `}
      ${((_j = theme.typography.mobile.text[textStyle]['text-decoration']) === null || _j === void 0 ? void 0 : _j.value) &&
        (0, styled_components_1.css) `
        text-decoration: ${(_k = theme.typography.mobile.text[textStyle]['text-decoration']) === null || _k === void 0 ? void 0 : _k.value};
      `}
    }
  `;
}}
`;
//# sourceMappingURL=Text.styled.js.map